export const transformToOldFormat = (phone: string): string => {
  const newNum = ['('].concat(phone.split(''));
  newNum.splice(4, 1, ')', ' ');
  return newNum.join('');
};

export const transformToNewFormat = (phone: string): string =>
  phone.replace('(', '').replace(')', '').replace(' ', '-');
